<template>
  <v-container>
    <h1 class="text-center" id="page-heading" v-html="pageTitle"></h1>
    <v-layout 
      text-xs-left
      wrap
      row
      class="prize-row"
    >
    <v-flex xs12 lg6 
      v-for="(item,i) in prizeData"
      :key="i">
      <v-card :class="[i%2==0 ? 'margin-right' : 'margin-left']">
        <v-img
          :src="item.src"
          class="white--text align-end"
          :gradient="gradientOverlay(item.soldOut)"
          max-height="100%"
          min-height="100"
          cover
        >  
        </v-img>
        <v-card-actions :class="[(book||friend) ? 'red-background' : 'light-blue-background', item.soldOut ? 'grey-background' : '']">
          <v-btn block rounded color="#fff" x-large class="refer-btn" @click="openDialog(item.link)" v-if="(book||friend)&&!item.soldOut">Book {{item.title}}</v-btn>
          <!-- v-btn block rounded color="#fff" x-large class="refer-btn" @click="openDialog(item.link)" v-if="friend&&!item.soldOut">Book {{item.title}}</!-->
          <h2 class="center uppercase" v-if="!book&&!friend">{{item.title}}</h2>
          <div id="eventbrite-widget-container-74114214611"></div>
        </v-card-actions>
        <v-expansion-panels class="margin-bottom flat">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="fas fa-caret-circle-down" :class="[(book||friend) ? 'red-background' : 'light-blue-background', item.soldOut ? 'grey-background' : '']" class="text-center text-white"><span>Find out more</span></v-expansion-panel-header>
            <v-expansion-panel-content light :class="[item.soldOut ? 'greyout' : '']">
              <v-card-text>
              <div
              v-for="(row, x) in item.contents"
                :key="x"
                >
                <h4 v-text="row.title" class="gnb-font"></h4>
                <p v-html="row.copy"></p>
              </div>
              <v-img
                :src="item.map"
                contain
                :gradient="gradientOverlay(item.soldOut)"
              ></v-img>
              <div
                v-for="(row, y) in item.venues"
                :key="y"
              >
                <v-layout :class="[y%2 ? 'purple-background' : 'light-grey-background']" class="table-padded">
                  <v-flex xs1 class="text-center">
                    <strong>{{row.number}}</strong>
                  </v-flex>
                  <v-flex auto>
                    <strong>{{row.title}}</strong><br />
                    {{row.address}}
                  </v-flex>
                </v-layout>
              </div>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        
      </v-card>
    </v-flex>
    </v-layout>
    <v-row justify="center">
      <v-dialog v-model="dialog" width="80vw" height="800px" @click:outside="frameLink=''">
        <v-card width="80vw" height="80vh">
          <v-progress-linear v-if="loading" x-large indeterminate color="primary"></v-progress-linear>
          <iframe @load="stopLoading(this)" :src="frameLink" width="100%" height="100%"></iframe>
        </v-card>
      </v-dialog>
    </v-row>
    <BackHome v-if="!book&&!friend" />
  </v-container>
</template>

<script>
import BackHome from '../components/BackHome'
export default {
  components: {
    BackHome
  },
  name: 'Prizes',
  props: ['id'],
  mounted() {
    this.init()
  },
  data: () => ({
    prizeData: [],
    dialog: false,
    loading: true,
    book: false,
    friend: false,
    frameLink : '',
    mapImage : {src:'https://via.placeholder.com/728x728.png?text=PLACEHOLDER+IMAGE'},
    pageTitle: 'Check out these great sporting experiences you could win'
  }),
  methods: {
    stopLoading: function () {
      this.loading = false
    },
    gradientOverlay: function (soldOut) {
      if(soldOut) {
        return "to bottom, rgba(0,0,0,.7), rgba(0,0,0,.7)"
      }else{
        return ''
      }
    },
    openDialog(link) {
      this.loading = true
      this.frameLink = 'https://www.eventbrite.com/checkout-external?eid='+link+'&parent='+window.location.href
      this.dialog = true
    },
    init() {
      this.axios.get('/data/prizes.json').then((response)=>{
        this.prizeData = response.data.payload
      })
      // check if book
      if(typeof this.id != 'undefined'){       
        var api = '/api/checkEntryFriend' 
        if(this.$router.currentRoute.name=='book') {
          this.book = true
          api = '/api/checkEntry' 
          this.pageTitle = 'To claim your prize, please choose from one of the following&nbsp;sports.'
        }else if(this.$router.currentRoute.name=='friend'){
          this.friend = true
          this.pageTitle = 'Please check the email sent to you for which sport you should&nbsp;book.'
        }
        var formData = new FormData()
        formData.append('hashString', this.id)
        this.axios.post(api, formData).then((response)=>{
          console.log(response);
          if(!response.data.success||response.data.payload.win<=0) {
            if(response.data.errors[0] == 'late') {
              this.$router.push('/expired')
            }else{
              this.$router.push('/')
            }
            //
            console.log(response.data.errors[0])
          }
        })
      }else{
        this.friend = false
        this.book = false
      }
    }
  },
  watch :{
    $route:function() {
      this.init()
    }
  }
};  
</script>
